import DetailsPreview from "./DetailsPreview/DetailsPreview";
import DetailsBookings from "./DetailsBookings/DetailsBookings";
import DetailsPlanning from "./DetailsPlanning/DetailsPlanning";
import DetailsDocuments from "./DetailsDocuments/DetailsDocuments";

export const DetailsTabs = () => {
    return [
        {
            label: 'Logement',
            path: 'apartment',
            component: <DetailsPreview />
        },
        {
            label: 'Réservations',
            path: 'bookings',
            component: <DetailsBookings />
        },
        {
            label: 'Planning',
            path: 'planning',
            component: <DetailsPlanning />
        },
        {
            label: 'Documents',
            path: 'documents',
            component: <DetailsDocuments />
        }
    ];
};
